module.exports = __webpack_public_path__ + "img/gemeente-enschede.b2741b9f.png";